'use client'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import React, { useEffect } from 'react'
import { isDesktop } from 'react-device-detect'

import bannerEvent from '@/utils/gaEvents/bannerEvent'

import Shared from '@/shared'
import Icons from '@/shared/components/icon/Icons'
import { Caption } from '@/shared/components/typography/index'

const TopBanner = () => {
  const pathname = usePathname()
  const { isBannerClosed, setIsBannerClosed } = Shared.States.useStorageStore()

  const URL_SCHEME = 'parkingshare://referral-code?code=JOIN2APP'
  const DESKTOP_URL =
    'https://socar-docs.zendesk.com/hc/ko/articles/50763514146329-%EB%AA%A8%EB%91%90%EC%9D%98%EC%A3%BC%EC%B0%A8%EC%9E%A5-%EC%8B%A0%EA%B7%9C%EA%B0%80%EC%9E%85-50-%ED%95%A0%EC%9D%B8'

  const bannerHref = isDesktop ? DESKTOP_URL : URL_SCHEME

  useEffect(() => {
    setIsBannerClosed(isBannerClosed !== true ? false : true)
  }, [isBannerClosed])

  const SCREEN_NAMES = {
    MAP: '지도화면',
    SEARCH: '검색화면',
    PARKINGLOT_DETAIL: '주차장상세화면',
    TICKET_DETAIL: '주차상품상세화면'
  }

  const handleClickBanner = () => {
    let screenName = pathname
    if (pathname.startsWith('/p')) {
      screenName = SCREEN_NAMES.PARKINGLOT_DETAIL
    } else if (pathname.startsWith('/t')) {
      screenName = SCREEN_NAMES.TICKET_DETAIL
    } else if (pathname.startsWith('/map')) {
      screenName = SCREEN_NAMES.MAP
      if (pathname.startsWith('/map/keyword')) {
        screenName = SCREEN_NAMES.SEARCH
      }
    }
    bannerEvent.onClickBanner(screenName)
  }

  const handleCloseBanner = () => {
    setIsBannerClosed(true)
  }

  if (!isBannerClosed !== true) {
    return null
  }

  return (
    <div className="sticky top-0 z-99 flex h-[54px] w-full max-w-[768px] bg-gray-080 px-5 py-[14px]">
      <div className="flex w-full items-center justify-between">
        <Link href={bannerHref} onClick={handleClickBanner} target={isDesktop ? '' : '_blank'} className="w-full">
          <Caption level="caption3" color="text010" weight="medium">
            모두의주차장 앱에서 <span className="text-main-030">50% 할인받기!</span>
          </Caption>
        </Link>
        <div className="flex items-center gap-3">
          <Icons.BannerCouponIcon />
          <Icons.CloseIcon12 fill="#ffffff" onClick={handleCloseBanner} className="cursor-pointer" />
        </div>
      </div>
    </div>
  )
}

export default TopBanner
